import {Injectable} from '@angular/core';
import {DatePipe} from '@angular/common';
import {BaseResponse, User, CheckhrElementsResponse, CheckhrElementResponse, CheckhrUsersResponse} from '../core/core.component';
import {Http, Headers, URLSearchParams} from '@angular/http';
import { environment } from 'environments/environment';
import {AppConstants} from '../core/app.constants';
import {Observable} from 'rxjs';
import 'rxjs/add/operator/map';
import {Subject} from 'rxjs/Subject';

@Injectable()
export class CheckhrService {

  private pattern = 'yyyy-MM-dd';

  private checkhrUserComponentStatus = new Subject<User>();

  constructor(private http: Http, private datePipe: DatePipe) {}

  getCheckhrElements(srmToken, descFilter?: string): Observable<CheckhrElementsResponse> {
    let url = environment.REST_SERVICE_BASE_URL + '/checkhr/checkhrElement';
    url = AppConstants.urlForNoCache(url);
    const headers = new Headers();
    headers.append(AppConstants.SRM_TOKEN_NAME, srmToken);
    const params: URLSearchParams = new URLSearchParams();
    if (descFilter != null && typeof (descFilter) !== 'undefined') {
      params.append('desc', descFilter);
    }
    return this.http.get(url, {search: params, headers: headers}).map((responseData) => responseData.json());
  }

  insertCheckhrElement(srmToken, desc: string, numGiorniValidita: number, numGiorniAlert: number): Observable<CheckhrElementResponse> {
    let url = environment.REST_SERVICE_BASE_URL + '/checkhr/checkhrElement';
    url = AppConstants.urlForNoCache(url);
    const headers = new Headers();
    headers.append(AppConstants.SRM_TOKEN_NAME, srmToken);
    const body = {
      desc: desc,
      numGiorniValidita: numGiorniValidita,
      numGiorniAlert: numGiorniAlert
    };
    return this.http.put(url, body, {headers: headers}).map((responseData) => responseData.json());
  }

  updateCheckhrElement(srmToken, id: number, desc: string, numGiorniValidita: number, numGiorniAlert: number): Observable<BaseResponse> {
    let url = environment.REST_SERVICE_BASE_URL + '/checkhr/checkhrElement/' + id;
    url = AppConstants.urlForNoCache(url);
    const headers = new Headers();
    headers.append(AppConstants.SRM_TOKEN_NAME, srmToken);
    const body = {
      desc: desc,
      numGiorniValidita: numGiorniValidita,
      numGiorniAlert: numGiorniAlert
    };
    return this.http.put(url, body, {headers: headers}).map((responseData) => responseData.json());
  }

  deleteCheckhrElement(srmToken, id: number): Observable<BaseResponse> {
    let url = environment.REST_SERVICE_BASE_URL + '/checkhr/checkhrElement/' + id;
    url = AppConstants.urlForNoCache(url);
    const headers = new Headers();
    headers.append(AppConstants.SRM_TOKEN_NAME, srmToken);
    return this.http.delete(url, {headers: headers}).map((responseData) => responseData.json());
  }

  getCheckhrUsers(srmToken, elCheckhrId?: number, userId?: number, dataDa?: Date, dataA?: Date, dataScadDa?: Date, dataScadA?: Date, storico?: boolean): Observable<CheckhrUsersResponse> {
    let url = environment.REST_SERVICE_BASE_URL + '/checkhr/checkhrUser';
    url = AppConstants.urlForNoCache(url);
    const headers = new Headers();
    headers.append(AppConstants.SRM_TOKEN_NAME, srmToken);
    const params: URLSearchParams = new URLSearchParams();
    if (elCheckhrId != null && typeof (elCheckhrId) !== 'undefined') {
      params.append('elCheckhrId', String(elCheckhrId));
    }
    if (userId != null && typeof (userId) !== 'undefined') {
      params.append('userId', String(userId));
    }
    if (dataDa != null && typeof (dataDa) !== 'undefined') {
      params.append('dateFrom', this.datePipe.transform(dataDa, this.pattern));
    }
    if (dataA != null && typeof (dataA) !== 'undefined') {
      params.append('dateTo', this.datePipe.transform(dataA, this.pattern));
    }
    if (dataScadDa != null && typeof (dataScadDa) !== 'undefined') {
      params.append('expDateFrom', this.datePipe.transform(dataScadDa, this.pattern));
    }
    if (dataScadA != null && typeof (dataScadA) !== 'undefined') {
      params.append('expDateTo', this.datePipe.transform(dataScadA, this.pattern));
    }
    if (storico != null && typeof (storico) !== 'undefined') {
      params.append('history', String(storico));
    }
    return this.http.get(url, {search: params, headers: headers}).map((responseData) => responseData.json());
  }

  insertCheckhrUser(srmToken, data: Date, userId: number, idCheck: number, dataScadenza?: Date, note?: string): Observable<BaseResponse> {
    let url = environment.REST_SERVICE_BASE_URL + '/checkhr/checkhrUser';
    url = AppConstants.urlForNoCache(url);
    const headers = new Headers();
    headers.append(AppConstants.SRM_TOKEN_NAME, srmToken);
    const body = {
      data: this.datePipe.transform(data, this.pattern),
      userId: userId,
      idCheck: idCheck,
      dataScadenza: this.datePipe.transform(dataScadenza, this.pattern),
      note: note
    };
    return this.http.put(url, body, {headers: headers}).map((responseData) => responseData.json());
  }

  updateNoteCheckhrUser(srmToken, data: Date, userId: number, idCheck: number, dataScadenza: Date, note?: string): Observable<BaseResponse> {
    let url = environment.REST_SERVICE_BASE_URL + '/checkhr/checkhrUser/updateNote';
    url = AppConstants.urlForNoCache(url);
    const headers = new Headers();
    headers.append(AppConstants.SRM_TOKEN_NAME, srmToken);
    const body = {
      data: this.datePipe.transform(data, this.pattern),
      userId: userId,
      idCheck: idCheck,
      dataScadenza: this.datePipe.transform(dataScadenza, this.pattern),
      note: note
    };
    return this.http.put(url, body, {headers: headers}).map((responseData) => responseData.json());
  }

  deleteCheckhrUser(srmToken, data: Date, userId: number, idCheck: number, dataScadenza: Date): Observable<BaseResponse> {
    let url = environment.REST_SERVICE_BASE_URL + '/checkhr/checkhrUser';
    url = AppConstants.urlForNoCache(url);
    const headers = new Headers();
    headers.append(AppConstants.SRM_TOKEN_NAME, srmToken);
    const body = {
      data: this.datePipe.transform(data, this.pattern),
      userId: userId,
      idCheck: idCheck,
      dataScadenza: this.datePipe.transform(dataScadenza, this.pattern)
    };
    return this.http.delete(url, {headers: headers, body: body}).map((responseData) => responseData.json());
  }

  getCheckhrAlertsCount(srmToken): Observable<BaseResponse> {
    let url = environment.REST_SERVICE_BASE_URL + '/checkhr/checkhrAlertsCount';
    url = AppConstants.urlForNoCache(url);
    const headers = new Headers();
    headers.append(AppConstants.SRM_TOKEN_NAME, srmToken);
    return this.http.get(url, {headers: headers}).map((responseData) => responseData.json());
  }
  
  getCheckhrAlertsList(srmToken): Observable<CheckhrUsersResponse> {
    let url = environment.REST_SERVICE_BASE_URL + '/checkhr/checkhrAlertsList';
    url = AppConstants.urlForNoCache(url);
    const headers = new Headers();
    headers.append(AppConstants.SRM_TOKEN_NAME, srmToken);
    return this.http.get(url, {headers: headers}).map((responseData) => responseData.json());
  }

  getCheckhrUserComponentStatus(): Observable<User> {
    return this.checkhrUserComponentStatus.asObservable();
  }

  openCheckhrUserComponent(user: User) {
    this.checkhrUserComponentStatus.next(user);
  }

  closeCheckhrUserComponent() {
    this.checkhrUserComponentStatus.next();
  }

}



// WEBPACK FOOTER //
// ./src/app/service/checkhr.service.ts